import { useEffect, useRef, useState } from "react";
import { Download, FileUp, Loader2, RotateCcw } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg, fetchFile, saveBlob } from "@/lib/api";

export const TemplateCard = () => {
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);
  const input = useRef(null);
  useEffect(() => {
    api.get("/report/template").then((r) => setInfo(r.data));
  }, []);

  const act = async (fn, ok) => {
    setBusy(true);
    try { setInfo((await fn()).data); toast.success(ok); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const upload = (f) => {
    if (!f) return;
    const fd = new FormData();
    fd.append("file", f);
    act(() => api.post("/report/template", fd), "Template PPT diganti");
    input.current.value = "";
  };
  const download = async () => {
    const file = await fetchFile("/report/template/file", {}, "template_laporan.pptx");
    saveBlob(file.blob, file.name);
  };

  return (
    <div data-testid="ppt-template-card" className="rounded-xl border bg-card p-5 shadow-sm">
      <h3 className="font-heading text-lg font-semibold">Template PPT</h3>
      <p className="text-sm text-muted-foreground">Dipakai untuk Laporan & Rapor. Template baru wajib memiliki layout: Title Slide, SECTION_HEADER, Content Slide 1, 1_Title Slide (unduh template aktif sebagai contoh).</p>
      <p data-testid="ppt-template-name" className="mt-3 text-sm">Aktif: <b>{info?.name || "-"}</b>{info?.custom && info.uploaded_at ? ` · diunggah ${new Date(info.uploaded_at).toLocaleString("id-ID")} oleh ${info.by}` : ""}</p>
      <div className="mt-4 flex flex-wrap gap-2">
        <input ref={input} type="file" accept=".pptx" className="hidden" data-testid="ppt-template-input" onChange={(e) => upload(e.target.files?.[0])} />
        <Button data-testid="ppt-template-upload-button" onClick={() => input.current.click()} disabled={busy}>
          {busy ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <FileUp className="mr-1.5 h-4 w-4" />}Ganti Template
        </Button>
        <Button data-testid="ppt-template-download-button" variant="outline" onClick={download}><Download className="mr-1.5 h-4 w-4" />Unduh Template Aktif</Button>
        {info?.custom && (
          <Button data-testid="ppt-template-reset-button" variant="ghost" disabled={busy} onClick={() => act(() => api.delete("/report/template"), "Kembali ke template bawaan")}>
            <RotateCcw className="mr-1.5 h-4 w-4" />Pakai Bawaan
          </Button>
        )}
      </div>
    </div>
  );
};
